export default "__VITE_ASSET__65eb7b75__"